
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
require('./bootstrap');

var Vue = require('vue');

window.bus = new Vue();

require('./scripts/notify.js');
require('./scripts/server.js')(Vue);
// require('./scripts/rellax.min.js');
require('./scripts/defaults.js');
require('./scripts/typer.js');
require('../common/VueCommonExtend.js')(Vue);
require('../common/CalculatorFormulas.js')(Vue);
require('../common/lightbox.min.js');
require('../common/refreshToken.js');
require('./VueExtend.js')(Vue);
require('./Notify.js')(Vue);
require('../admin/plugins/OwlCarousel/owl.carousel.min.js');
require('../admin/plugins/Dropzone/dropzone.min.js')(Vue);
require('../admin/plugins/ImageHandler/cropper.min.js');
require('../admin/plugins/Summernote/summernote-lite.js');
require('./VueComponents.js')(Vue);

//VUEX Store state
import Vuex from 'vuex';
const store = require('./VueStore.js')(Vue, Vuex);

// VUE ROUTER
import VueRouter from 'vue-router';
Vue.use( VueRouter );

const routes = require('./routes.js')(Vue, store);
const router = new VueRouter({ 
    routes,  
    hashbang: false, 
    mode: 'history',
});

router.beforeEach((to, from, next) => {
    bus.$emit('page-change', to);
    next();
})

router.afterEach((to, from) => {
    bus.$emit('page-change-after', to);
})

const app = new Vue({
    el: '#app',

    mounted(){
        var me = this;

        bus.$on('loader', ( show ) => {
            show ? 
                me.$store.commit('showLoader') : 
                me.$store.commit('hideLoader');
        })
    },


    //VuexStore
    store,

    //Vue Router
    router

});